import { render, staticRenderFns } from "./cModalViewDispatchAct.vue?vue&type=template&id=0845ab8f"
import script from "./cModalViewDispatchAct.vue?vue&type=script&lang=js"
export * from "./cModalViewDispatchAct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports